module.exports = __webpack_public_path__ + "img/sto_rtt.f15470c5.jpg";